import React from 'react';
import SectionHeader from './SectionHeader';
import { LOGLINE } from '../mock';

export default function Logline() {
  return (
    <section id="logline" className="section-pad relative">
      <div className="container-narrow">
        <SectionHeader chapter={LOGLINE.chapter} label={LOGLINE.label} heading={LOGLINE.heading} />
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-2 hidden lg:block">
            <div className="h-full w-px bg-[color:var(--bx-gold)]/20 mx-auto" />
          </div>
          <div className="lg:col-span-10">
            <p className="font-serif text-2xl md:text-3xl leading-[1.4] text-[color:var(--bx-bone)] italic">
              {LOGLINE.body}
            </p>
            <div className="mt-10 flex items-center gap-4">
              <span className="h-px w-12 bg-[color:var(--bx-gold)]" />
              <span className="font-sc text-[10px] gold-text tracking-[0.4em]">{LOGLINE.footer}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
